import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class CompanyMentorGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Mentor List',
            ROUTE_PATH.internshipCompanyMentor,
            ROUTE_PATH.internshipComapny,
            true,
            true,
            8,
            false,
            true,
            ['mentorName'],
            true,
            [],
            { isDownloadExcel: true, excelFileName: 'InternshipLocationList' + new Date().toLocaleDateString() + '.xlsx', btnLabel: 'Download List', headers: [
                { key: 'Mentor_Name', value: 'mentorName' },
                { key: 'Mentor-Email', value: 'mentorEmail' },
                { key: 'Phone', value: 'mentorMobile' },
                { key: 'Department', value: 'mentorDepartment' },
                { key: 'Role', value: 'mentorRole' },
                { key: 'City', value: 'mentorCity' },
            ] },
            false,
            { evalKey: 'openFormModal', evalParam: [1], decisiveParam: false},
            false,
            true,
            false,
            null,
            { evalKey: 'isDeletable', evalParam: ["0"], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            true,
            [],
            false,
            {
                isExtraActions: false,
                btnLabel: '',
                selectOptions: [
                
                ],
                selectedValue: '',
              },
              {
                isCheckboxEmit: true,
                emitKey: 'id',
                checkedKey: '',
                valueKey: '',
              },
              { isDownload: false, key: '', valueKey: '' },
              { isTabStatus: false, label: '', isChecked: false },
              false,
              true,
              {
                isPrimary: false,
                isDanger: true,
              },
              '',
              {
                value:'',
                isVisible:true
              },
              true,
              true,
              false,
              {isExtraActions:false,btnLabel:''},
              {value:'Mentor',isVisible:true}

        );
    }

    override initProperties() {
      const dataInfo = super.initProperties();
         const isEdit:boolean=false;
      dataInfo.isEdit = isEdit
      return dataInfo
  }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const mentor_name = new Headers('Mentor Name', 'mentorName', false, true, 'text');
        const email = new Headers('Mentor E-mail', 'mentorEmail', false, true, 'text');
        const phone = new Headers('Phone', 'mentorMobile', false, true, 'text');
        const department = new Headers('Department', 'mentorDepartment', false, true, 'text');
        const role = new Headers('Role', 'mentorRole', false, true, 'text');
        const city = new Headers('City', 'mentorCity', false, true, 'text');


        headers.push(mentor_name);
        headers.push(email);
        headers.push(phone);
        headers.push(department);
        headers.push(role);
        headers.push(city);


        return headers;
    }
}
